export class TabAccountInfoConstants {
    static readonly individual: string = 'individual';
    static readonly company: string = 'company';
    static readonly artist: string = 'artist';
}